<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <!-- <span class="masge">当前共有{{ total }}条{{this.route.menuName}}</span> -->
      </div>
      <el-row>
        <el-col :span="12" style="padding: 0px 5px 0px 0px">
          <div class="header">
            <div class="left" style="width: 120px">
              <span class="text">患者明细</span>
            </div>
            <div class="right">
              <div class="search1">
                <el-row>
                  <el-col :span="12">
                    <el-input type="text" v-model="patientQuery.keyWord" placeholder="请输入住院号" @change="patientSearch"
                      style="width: 100%" />
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="patientQuery.deptId" filterable clearable :filter-method="getDepts"
                      style="width: 100%" placeholder="请选择科室" @change="patientSearch">
                      <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.no + ' ' + item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <!-- <i class="el-icon-search padding10" v-preventReClick @click="patientSearch"></i> -->
              </div>
            </div>
          </div>

          <el-table ref="patientTable" border v-loading="patientLoading" :data="patientTableData" height="361"
            style="width: 100%" @current-change="patientTableSelect" highlight-current-row stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <!-- <div class="empty-rest" @click="reset">恢复默认</div> -->
              </div>
            </template>
            <el-table-column :show-overflow-tooltip="true" width="100" prop="no" label="住院号"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="80" prop="name" label="患者姓名"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100" prop="deptName" label="患者科室"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="50" prop="age" label="年龄"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="50" prop="sexName" label="性别"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100" prop="inHospitalDate" label="入院日期">
              <template slot-scope="scope">
                {{ parseTime(new Date(scope.row.inHospitalDate), "{y}-{m}-{d}") }}
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="120" prop="idcard" label="身份证号码"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="80" prop="doctorName" label="医生姓名"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100" prop="doctorDeptName"
              label="所属科室"></el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :current-page="patientQuery.pageIndex"
              :total="patientPageTotal" @current-change="patientPageChange">
            </el-pagination>
          </div>
        </el-col>
        <el-col :span="12" style="padding: 0px 0px 0px 5px">
          <div class="header">
            <div class="left" style="width: 120px">
              <span class="text">产品明细</span>
            </div>
            <div class="right">
              <div class="search1">
                <el-row>
                  <el-col :span="8">
                    <el-input type="text" v-model="productQuery.productName" placeholder="请输入产品名称"
                      @change="productSearch" style="width: 100%" />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="productQuery.specName" placeholder="请输入规格型号" @change="productSearch"
                      style="width: 100%" />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="productQuery.manufacturerName" placeholder="请输入生产厂家"
                      @change="productSearch" style="width: 100%" />
                  </el-col>
                </el-row>
                <div style="height: 10px"></div>
                <el-row>
                  <el-col :span="8">
                    <el-input type="text" v-model="productQuery.mainNo" placeholder="请输入UDI主条码" @change="productSearch"
                      style="width: 100%" />
                  </el-col>
                  <el-col :span="8">
                    <el-input type="text" v-model="productQuery.traceNo" placeholder="请输入UDI溯源码" @change="productSearch"
                      style="width: 100%" />
                  </el-col>
                  <el-col :span="8">
                    <el-select v-model="productQuery.supplierProductId" filterable clearable
                      :filter-method="getProductList" style="width: 100%" placeholder="请选择产品" @change="productSearch">
                      <el-option v-for="item in STATIC_SupplierProducts" :key="item.id"
                        :label="item.productName + ' ' + item.specName" :value="item.id"></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>

          <el-table ref="productTable" border v-loading="productLoading" :data="productTableData" height="361"
            style="width: 100%" highlight-current-row @current-change="productTableSelect" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <!-- <div class="empty-rest" @click="reset">恢复默认</div> -->
              </div>
            </template>
            <el-table-column :show-overflow-tooltip="true" prop="mainNo" width="100" label="主条码"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="traceNo" width="100" label="溯源码"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productName" width="130"
              label="产品名称"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specName" width="90" label="规格/型号"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productRegistCertNo" width="100"
              label="注册证号"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productRegistCertName" width="110"
              label="注册证号名称"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="supplierName" width="130"
              label="供应商"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="manufacturerName" width="130"
              label="生产厂家"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" width="80" label="数量"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="minUnit" width="80" label="最小单位"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="price" width="80" label="计费价"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="amount" width="80" label="小计"></el-table-column>
            <el-table-column prop="validityDate" width="120" label="有效期">
              <template slot-scope="scope">{{
                parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="batch" width="100" label="批号"></el-table-column>
            <el-table-column prop="manufactureDate" width="120" label="生产日期">
              <template slot-scope="scope">{{
                parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                }}</template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="serialNo" width="100" label="序列号"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100" label="灭菌日期"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="100" label="灭菌有效期"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="inStockTypeName" width="100"
              label="入库类型"></el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :current-page="productQuery.pageIndex"
              :total="productPageTotal" @current-change="productPageChange">
            </el-pagination>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="header">
            <div class="left">
              <span class="text">出入库明细</span>
            </div>
          </div>
          <el-table ref="patientTable" border v-loading="storageLoading" :data="orderTableData" style="width: 100%" stripe
            :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <!-- <div class="empty-rest" @click="reset">恢复默认</div> -->
              </div>
            </template>
            <el-table-column :show-overflow-tooltip="true" width="250" prop="no" label="单号"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="220" prop="type" label="单据类型"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" width="230" prop="warehouseName"
              label="库房"></el-table-column>

            <el-table-column :show-overflow-tooltip="true" width="230" prop="createdUserName"
              label="创建人"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="createdTime" label="创建时间">
              <template slot-scope="scope">{{
                parseTime(new Date(scope.row.createdTime))
                }}</template>
            </el-table-column>
          </el-table>

          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :current-page="orderQuery.pageIndex"
              :total="orderTablePageTotal" @current-change="orderPageChange">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  GetPatientDetails,
  GetOrdersBySupplierProductId,
  GetReportSupplierProducts,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    // SelectFilter,
  },
  data () {
    return {
      productQuery: {
        patientId: "",
        supplierProductId: "",
        pageIndex: 1,
        pageSize: 8,
      },
      patientQuery: {
        keyWord: "",
        patientIds: "",
        pageIndex: 1,
        pageSize: 8,
      },
      orderQuery: {
        pageIndex: 1,
        pageSize: 10,
      },
      patientLoading: false,
      storageLoading: false,
      productLoading: false,
      productTableData: [],
      patientTableData: [],
      orderTableData: [],
      orderData: [],
      productPageTotal: 0,
      patientPageTotal: 0,
      orderTablePageTotal: 0,
    };
  },
  methods: {
    getSupplierProductData () {
      GetReportSupplierProducts(this.productQuery)
        .then((res) => {
          if (res.successful) {
            this.productPageTotal = res.returnData.totalCount || 0;
            this.productTableData = res.returnData.data;
          } else {
            this.$my_message(`${res.errorMessage}`, "error");
          }
        })
        .finally(() => {
          this.productLoading = false;
        });
    },
    getPatientData () {
      GetPatientDetails(this.patientQuery)
        .then((res) => {
          if (res.successful) {
            this.patientPageTotal = res.returnData.totalCount || 0;
            this.patientTableData = res.returnData.data;
          } else {
            this.$my_message(`${res.errorMessage}`, "error");
          }
        })
        .finally(() => {
          this.patientLoading = false;
        });
    },
    getOrdersBySupplierProductId (row) {
      if (!row) {
        this.orderTableData = [];
        return;
      }

      let query = {
        inStockType: row.inStockType,
        supplierProductId: row.supplierProductId,
        traceNo: row.traceNo,
        batch: row.batch,
        manufactureDate: row.manufactureDate,
        validityDate: row.validityDate,
        serialNo: row.serialNo,
        locationId: row.locationId,
        warehouseId: row.warehouseId,
        orgCode :sessionStorage.getItem('orgId')
      };

      GetOrdersBySupplierProductId(query)
        .then((res) => {
          if (res.successful) {
            this.orderData = res.returnData;
            this.orderTablePageTotal = this.orderData ? this.orderData.length : 0;
            this.orderTableData = this.getPaginationData(
              this.orderData,
              this.orderQuery.pageIndex,
              this.orderQuery.pageSize
            );
          } else {
            this.$my_message(`${res.errorMessage}`, "error");
          }
        })
        .finally(() => {
          this.storageLoading = false;
        });
    },
    getPaginationData (list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    // 触发搜索按钮
    productSearch () {
      this.$set(this.productQuery, "pageIndex", 1);
      this.$set(this.productQuery, "patientId", "");
      this.productLoading = true;
      this.getSupplierProductData();
      this.orderData = [];
      this.orderTableData = [];
      this.orderTablePageTotal = 0;
      this.orderQuery.pageIndex = 1;
    },
    patientSearch () {
      this.$set(this.patientQuery, "pageIndex", 1);
      this.$set(this.patientQuery, "patientIds", "");
      this.patientLoading = true;
      this.getPatientData();
    },
    // 分页导航
    productPageChange (val) {
      this.$set(this.productQuery, "pageIndex", val);
      this.getSupplierProductData();
    },
    patientPageChange (val) {
      this.$set(this.patientQuery, "pageIndex", val);
      this.getPatientData();
    },
    orderPageChange (val) {
      this.$set(this.orderQuery, "pageIndex", val);
      this.orderTableData = this.getPaginationData(
        this.orderData,
        this.orderQuery.pageIndex,
        this.orderQuery.pageSize
      );
    },
    productTableSelect (row) {
      if (!row) return;
      this.$refs.patientTable.setCurrentRow();
      this.$set(this.patientQuery, "pageIndex", 1);
      this.$set(this.patientQuery, "patientIds", row.patientIds);
      this.$set(this.patientQuery, "keyWord", "");
      this.getPatientData();
      this.storageLoading = true;
      this.getOrdersBySupplierProductId(row);
    },
    patientTableSelect (row) {
      if (!row) return;
      this.$refs.productTable.setCurrentRow();
      console.log(row.parentId,row.id,row);
      
      this.$set(this.productQuery, "patientId", row.parentId);
      this.$set(this.productQuery, "supplierProductId", "");
      this.$set(this.productQuery, "pageIndex", 1);
      this.productLoading = true;
      this.getSupplierProductData();
      this.orderTableData = [];
    },

    getProductList (keyWord) {
      this.getSupplierProducts({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
      });
    },
  },
  mounted () { },
  created () {
    this.getSupplierProductData();
    this.getProductList("");
    this.getPatientData();
    this.getDepts("");
  },
};
</script>

<style lang="scss" scoped>
.right {
  display: flex;
  align-items: normal !important;
  color: #909399;
  font-size: 12px;

  // .date {
  //   margin-right: 20px;
  //   height: 32px;

  //   div {
  //     height: 32px;
  //     border: none;
  //     background-color: #e4e4e4;

  //     input {
  //       height: 32px;
  //       background-color: #e4e4e4;
  //     }
  //   }
  // }

  //   .search1 {
  //     // width: 180px;
  //     height: 33px;
  //     // margin-left: 805px;
  //     background: #fff !important;
  //     line-height: 32px;
  //     margin-right: 15px;
  //     border-radius: 2px;
  //   }

  //   // span,
  //   // i {
  //   //   cursor: pointer;
  //   // }
}

// input {
//   width: 150px;
//   height: 30px;
//   background-color: #e4e4e4;
//   border: none;
//   outline: none;
//   padding-left: 10px;
// }
// select {
//   // margin-right: 10px;
//   // width: 100% !important;
//   height: 30px;
//   box-sizing: border-box;
//   border: 0px solid #e4e4e4;
//   outline: none;
//   background-color: #e4e4e4;
// }
.header {
  height: 90px !important;
  align-items: normal !important;
}
</style>
